<template>
    <div class="mx-2 mx-lg-5">
        <div class="mb-1 mt-3">
            <button class="btn btn-primary btn-sm px-3 py-2 d-flex flex-row justify-content-center align-items-center"
                @click="goToEdit">
                <icon icon="Edit"></icon>
                <span class="ms-2 fs-6 fw-bold">{{ $t("utils.editDetails") }}</span>
            </button>
        </div>
        <div class="card mt-3">
            <div class="card-header d-flex justify-content-between align-items-center">
                <h3>{{ event.title }}</h3>
                <button
                    v-if="$store.getters.hasGatehousePerm('delete_repeatingevent')"
                    class="btn btn-sm btn-danger"
                    @click="deleteEvent"
                >
                    <icon icon="Trash"></icon>
                </button>
            </div>
            <div class="card-body">
                <div class="row">
                    <dt class="col-sm-4">{{ $t("repeatingEvents.frequency") }}</dt>
                    <dd class="col-sm-8">{{ event.interval_days }}</dd>

                    <dt class="col-sm-4">{{ $t("repeatingEvents.startAt") }}</dt>
                    <dd class="col-sm-8">{{ event.repeat_from ? $d(new Date(event.repeat_from), "dateOnly") : "--   " }}</dd>

                    <dt class="col-sm-4">{{ $t("repeatingEvents.finishAt") }}</dt>
                    <dd class="col-sm-8">{{ event.repeat_to ? $d(new Date(event.repeat_to), "dateOnly") : "--" }}</dd>
                </div>
            </div>
        </div>

        <div class="card mt-3">
            <div class="card-header">
                <h3>{{ $t("repeatingEvents.relatedEvents") }}</h3>
            </div>
            <div class="card-body">
                <VehicleEntryProvider
                    v-if="event.event_type === 'vehicle_entry'"
                    :api-url="vehiclesApiUrl"
                    v-slot="p"
                >
                    <VehicleEntryTable
                        :items="p.items"
                        :total-count="p.totalCount"
                        :page="p.page"
                        :per-page="p.perPage"
                        @page-change="p.setPage"
                        @per-page-change="p.setPerPage"
                        @refresh="() => handleVehicleRefresh(p)"
                    />
                </VehicleEntryProvider>

                <GuestbookProvider
                    v-else
                    :api-url="guestbooksApiUrl"
                    v-slot="p"
                >
                    <GuestbookTable
                        :items="p.items"
                        :total-count="p.totalCount"
                        :page="p.page"
                        :per-page="p.perPage"
                        @page-change="p.setPage"
                        @per-page-change="p.setPerPage"
                        @refresh="() => handleGuestbookRefresh(p)"
                    />
                </GuestbookProvider>
            </div>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import GuestbookTable from '@/components/GuestbookTable.vue';
import VehicleEntryTable from '@/components/VehicleEntryTable.vue';
import VehicleEntryProvider from '@/components/VehicleEntryProvider.vue';
import GuestbookProvider from '@/components/GuestbookProvider.vue';

export default {
    components: {
        Icon,
        GuestbookTable,
        VehicleEntryTable,
        VehicleEntryProvider,
        GuestbookProvider,
    },
    data() {
        return {
            event: {}
        }
    },
    created() {
        this.getRepeatingEvent();
    },
    computed: {
        vehiclesApiUrl() {
            return `/${this.$route.params.slug}/repeating-events/${this.$route.params.id}/vehicle-entries`;
        },
        guestbooksApiUrl() {
            return `/${this.$route.params.slug}/repeating-events/${this.$route.params.id}/guestbooks`;
        }
    },
    methods: {
        getRepeatingEvent() {
            this.$store.getters.api.get(`/${this.$route.params.slug}/repeating-events/${this.$route.params.id}`)
            .then(res => {
                this.event = res.data;
            })
            .catch(error => {
                console.error("Error loading repeating event", error);
            });
        },
        goToEdit() {
            this.$router.push({
                name: "RepeatingEventEditView",
                params: {
                    slug: this.$route.params.slug,
                    id: this.event.id
                }
            })
        },
        deleteEvent() {
            const confirm = window.confirm(this.$t("utils.deleteQuestion"));
            if (!confirm) return;

            this.$store.getters.api.delete(`/${this.$route.params.slug}/repeating-events/${this.$route.params.id}/delete`)
                .then(() => {
                    this.$router.push({
                        name: "RepeatingEvents",
                        params: { slug: this.$route.params.slug }
                    })
                })
                .catch(error => {
                    console.error("Error deleting repeating event", error);
                });
        },
        handleVehicleRefresh(provider) {
            provider.refresh();
            this.getRepeatingEvent();
        },
        handleGuestbookRefresh(provider) {
            provider.refresh();
            this.getRepeatingEvent();
        },
    },
}
</script>